import { render, staticRenderFns } from "./artefact-image-group.vue?vue&type=template&id=e98bd81c&scoped=true&"
import script from "./artefact-image-group.vue?vue&type=script&lang=ts&"
export * from "./artefact-image-group.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-image-group.vue?vue&type=style&index=0&id=e98bd81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98bd81c",
  null
  
)

export default component.exports